import { create } from 'mobx-persist';

import ChatStore from './ChatStore';
import IdentityStore from './IdentityStore';
import MockChatStore from './MockChatStore';

class RootStore {
  public identityStore: IdentityStore;
  public chatStore: ChatStore;
  public mockChatStore: MockChatStore;

  private hydrate: any;
  private apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
    this.identityStore = new IdentityStore(this);
    this.chatStore = new ChatStore(this);
    this.mockChatStore = new MockChatStore(this);

    this.hydrate = create();
  }

  public async readState() {
    await this.hydrate(`${this.apiKey}-id`, this.identityStore);
    await this.hydrate(`${this.apiKey}-chat`, this.chatStore);
  }

  public clearAllState() {
    return localStorage.clear();
  }
}

export default RootStore;
